import { render, staticRenderFns } from "./DeliveryResponsibleDialog.vue?vue&type=template&id=48470502"
import script from "./DeliveryResponsibleDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryResponsibleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports